function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M22 4.01c-1 .49-1.98.689-3 .99-1.121-1.265-2.783-1.335-4.38-.737S11.977 6.323 12 8v1c-3.245.083-6.135-1.395-8-4 0 0-4.182 7.433 4 11-1.872 1.247-3.739 2.088-6 2 3.308 1.803 6.913 2.423 10.034 1.517 3.58-1.04 6.522-3.723 7.651-7.742a13.84 13.84 0 00.497-3.753C20.18 7.773 21.692 5.25 22 4.009z"
});

function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "#fff",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDI0IDI0IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlPSIjZmZmZmZmIiBmaWxsPSJub25lIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPgogIDxwYXRoIGQ9Ik0yMiA0LjAxYy0xIC40OS0xLjk4LjY4OS0zIC45OS0xLjEyMS0xLjI2NS0yLjc4My0xLjMzNS00LjM4LS43MzdTMTEuOTc3IDYuMzIzIDEyIDh2MWMtMy4yNDUuMDgzLTYuMTM1LTEuMzk1LTgtNCAwIDAtNC4xODIgNy40MzMgNCAxMS0xLjg3MiAxLjI0Ny0zLjczOSAyLjA4OC02IDIgMy4zMDggMS44MDMgNi45MTMgMi40MjMgMTAuMDM0IDEuNTE3IDMuNTgtMS4wNCA2LjUyMi0zLjcyMyA3LjY1MS03Ljc0MmExMy44NCAxMy44NCAwIDAgMCAuNDk3IC0zLjc1M0MyMC4xOCA3Ljc3MyAyMS42OTIgNS4yNSAyMiA0LjAwOXoiIC8+Cjwvc3ZnPg==";
export { SvgTwitter as ReactComponent };